import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useToken } from '../../Flow/ConsentContextProvider';

export default function DocumentTitle() {
  const { clientName } = useToken();
  const intl = useIntl();

  useEffect(() => {
    document.title = intl.formatMessage(
      {
        id: 'partnercentral.documentTitle',
        defaultMessage: 'Authorize App | {appName}',
      },
      {
        appName: clientName,
      },
    );
  }, [clientName, intl]);

  return null;
}
